import { render } from "./TableItemsPerPageSelect.vue?vue&type=template&id=2cd82630&scoped=true"
import script from "./TableItemsPerPageSelect.vue?vue&type=script&lang=ts"
export * from "./TableItemsPerPageSelect.vue?vue&type=script&lang=ts"

import "./TableItemsPerPageSelect.vue?vue&type=style&index=0&id=2cd82630&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2cd82630"

export default script